export class RecoveryPass{
    correo: string;
    pass: string;
}